// ─── Gli account Telegram di un socio — un account per scheda (A7) ──────────
//
// 🗣️ 28/09/2026, regolamento «registrazione e invito amici», regola A7, mockup
// `mockup/a7-account-gia-collegato-mockup.html` approvato (*«mockup approvato,
// scelte consigliate, procedi»* ⇒ A · A · A · A):
//   1A il GESTIONALE tiene l'elenco degli account collegati e decide se un
//      account nuovo può entrare: il bot chiede «collego?» prima di ammettere;
//   2A la Segreteria vede l'account nella scheda e lo SCOLLEGA, col motivo;
//   3A le schede che hanno già due account restano come sono, segnate;
//   4A il vecchio account scollegato non riceve messaggi.
//
// 🔒 La regola: una scheda che ha già un account collegato non ne prende un
// altro. Chi ha cambiato telefono passa dalla Segreteria, che scollega il
// vecchio; da lì il nuovo entra condividendo il numero.
import { z } from 'zod';
/** Una chat privata di Telegram: l'id dell'utente, in cifre (come testo, perché supera i 32 bit). */
export const chatTelegramSchema = z.string().regex(/^-?[0-9]{1,20}$/);
/** Il bot chiede di collegare la chat di chi sta entrando alla sua scheda. */
export const domandaCollegamentoSchema = z.object({
    chatId: chatTelegramSchema,
    /** Il nome che Telegram mostra a tutti, per riconoscere l'account in Segreteria. */
    name: z.string().trim().max(128).nullable().default(null),
    /** L'@nome, senza `@`, se c'è. */
    username: z.string().trim().max(64).nullable().default(null),
    /**
     * 🔒 Quando ha accettato la privacy policy dall'assistente (29/09/2026, scelta 8A): l'istante in cui
     * è arrivato il suo contatto. Sulla scheda si scrive solo la prima volta.
     */
    privacyAcceptedAt: z.iso.datetime().nullable().default(null),
});
/**
 * Il verdetto.
 * - `fatto`: la chat è collegata (adesso, o lo era già: ripetere non cambia niente);
 * - `rifiutato` con `gia_collegata`: la scheda ha un altro account, e la chat NON si collega.
 */
export const esitoCollegamentoSchema = z.object({
    outcome: z.enum(['fatto', 'rifiutato']),
    reason: z.string().nullable(),
    code: z.enum(['gia_collegata']).nullable(),
});
/** La frase per il socio fermato. In positivo, e con la strada: la dice il bot. */
export const GIA_COLLEGATA = 'Questo numero è già collegato a un altro account Telegram: per proteggere la tua scheda, il collegamento lo sposta la Segreteria.';
/**
 * Le chat che il bot ha già ammesso, mandate una volta all'avvio (scelta 3A):
 * il gestionale impara i collegamenti di prima, doppi compresi.
 */
export const sincroniaCollegamentiSchema = z.object({
    links: z
        .array(z.object({ memberId: z.uuid(), chatId: chatTelegramSchema, since: z.iso.datetime() }))
        .max(20000),
});
export const esitoSincroniaSchema = z.object({ added: z.number().int(), known: z.number().int() });
/** Gli scollegamenti dopo un istante: il bot, nel suo giro, chiude quelle chat. */
export const domandaScollegatiSchema = z.object({ since: z.iso.datetime() });
export const scollegatiSchema = z.object({
    unlinked: z.array(z.object({ memberId: z.string(), chatId: chatTelegramSchema, unlinkedAt: z.iso.datetime() })),
});
// ── La scheda del socio, in Segreteria ───────────────────────────────────────
export const accountTelegramSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    username: z.string().nullable(),
    linkedAt: z.iso.datetime(),
});
export const accountScollegatoSchema = accountTelegramSchema.extend({
    unlinkedAt: z.iso.datetime(),
    /** Chi l'ha scollegato: il nome di chi lavora in Segreteria, `null` se è stato il sistema. */
    unlinkedBy: z.string().nullable(),
    reason: z.string(),
});
export const telegramDelSocioSchema = z.object({
    linked: z.array(accountTelegramSchema),
    history: z.array(accountScollegatoSchema),
    /** 🔒 Quando ha accettato la privacy policy dall'assistente; `null` = non ancora. */
    privacyAcceptedAt: z.iso.datetime().nullable(),
});
/** I motivi che la Segreteria sceglie; «Altro» vuole il motivo scritto. */
export const MOTIVI_SCOLLEGA = [
    'Ha cambiato telefono o account Telegram',
    'L’account non è del socio',
];
export const scollegaSchema = z.object({
    reason: z.string().trim().min(3, 'Scrivi il motivo: resta nello storico della scheda.').max(300),
});
/** Il motivo che il sistema scrive quando una chat passa da sola a un'altra scheda. */
export const PASSATO_AD_ALTRA_SCHEDA = 'Lo stesso account è entrato con un’altra scheda';
//# sourceMappingURL=account-telegram.js.map